import { Button, Form } from '@frontendmentorio/design-system-v2';

import GeneralInfo from './GeneralInfo';
import Preview from './RetrospectivePreview';
import Retrospective from './Retrospective';

export default function ChallengeForm({ onSubmit: handleSubmit, solution }) {
  return (
    <Form onSubmit={handleSubmit}>
      <GeneralInfo solution={solution} />
      <Retrospective solution={solution} />
      <Preview solution={solution} />

      <Button className="self-end" isWide>
        {solution ? 'Update solution' : 'Submit solution'}
      </Button>
    </Form>
  );
}
